(function() {
  "use strict";

  angular.module("app").factory("rankingsService", [RankingsService]);

  function RankingsService() {
    return {
      lowestRanked: function(rankedCommunities) {
        if (!rankedCommunities) return [];

        var lowestRank = _.first(rankedCommunities).rank;
        return rankedCommunities.filter(function(cd) {
          return cd.rank === lowestRank;
        });
      },
      highestRanked: function(rankedCommunities) {
        if (!rankedCommunities) return [];

        var highestRank = _.last(rankedCommunities).rank;
        return rankedCommunities.filter(function(cd) {
          return cd.rank === highestRank;
        });
      }
    };
  }
})();
